import { Component, OnInit, Input, Output, forwardRef, EventEmitter } from '@angular/core';
import { FormBuilder, UntypedFormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR, ControlValueAccessor, Validators } from '@angular/forms';
import { FundSource } from 'src/app/model/fund-source';


@Component({
  selector: 'app-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.scss'],
  providers: [
    {
      provide: NG_VALIDATORS, useExisting: TextInputComponent, multi: true
    },
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextInputComponent),
      multi: true
    }]
})
export class TextInputComponent implements OnInit {
  @Input() controllerData;
  @Input() parent: UntypedFormGroup;
  @Input() pageName: string;
  @Input() controlName: string;
  @Input() sourceData: FundSource;
  @Input() toUpperCase = false;
  @Input() isNumeric = false;
  @Output() textChangeEventEmitter: EventEmitter<string> = new EventEmitter<string>();
  onTouched: () => void;
  onChange = (value: string) => { };
  public textValue: string;
  /**
   * This is a constructor
   */
  constructor() {
  }

  ngOnInit() {
   
    if(this.parent.get([this.controlName])){
      this.textValue = this.parent.get([this.controlName]).value;
    }
    else{
      this.textValue = "";
    }
   
    // this.setMiddleNameValidators();
  }
  writeValue(value: any): void {
    this.controllerData['value'] = value ? value : null;
  }
  registerOnChange(fn) {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  getId() {
    let newId: string;
    if (this.controllerData['controlName'] === 'productCode' && this.sourceData && this.sourceData['code'] === 'J') {
      newId = this.sourceData['sourceName'] + this.controllerData['controlName'] + this.controlName;
    } else {
      newId = this.controllerData['name'];
    }
    return newId;
  }

  inputTextChangeHandler(val) {
    /*  if( this.controlName ==='sortcode'){
      if (val && val.length == 6) {
            let formattedSortCode = ((val).toString().match(/.{1,2}/g) || []).join('-');
            this.textChangeEventEmitter.emit(formattedSortCode);
        this.parent.get(this.controllerData.controlName).setValue(formattedSortCode);

    }
    } 
    else{  */
    if(this.sourceData && (this.sourceData['code'] == 'H' || this.sourceData['code'] == 'F' || this.sourceData['code'] == 'O')) {
      this.parent.value [0] =  val;
    } 
    this.textChangeEventEmitter.emit(val);
  
    //}
//}
  }
   addhyphen(data,event){
    if( this.controlName ==="sortcode" ){
      /* to enable onlu numbers to be entered */
      if( event.charCode > 31 && event.charCode < 48 || event.charCode > 57)
      {
        event.preventDefault();

      }else {
      const inputLength = data.length + 1;
      if (event.keyCode !== 8) {
        if (inputLength === 2 || inputLength === 5) {
          data = data + parseInt(event.key) + '-';
          const thisVal = data;
          // //console.log(thisVal);
          this.parent.get(this.controllerData.controlName).setValue(thisVal);

          event.preventDefault();
        }
      }
    }
  }
  if(this.controlName ==="accountNumber"){
    /* to enable onlu numbers to be entered */
    if( event.charCode > 31 && event.charCode < 48 || event.charCode > 57)
    {
      event.preventDefault();

    }
  }
  }   

  validate() {
    // tslint:disable-next-line : max-line-length
    const nameValidation: RegExp = /^[a-zA-Z0-9_\-\\/]{1,50}$/g;
    const forbidden = nameValidation.test(this.parent.get(this.controlName).value);


    if (this.controlName === 'textplanNumber' && this.parent.get(this.controlName).value) {
      return forbidden ? null : { notValidPlanNumber: true };
      // tslint:disable-next-line:align
    } return null;
  }
  /* validateInput = () => {
    this.onChangeHandler.emit();
  } */



}
